module.exports = __webpack_public_path__ + "media/fonts/alternate-gothic-no3-regular-webfont-1ee2503a00f5ce541935d5c0bc8eeacd.woff";